import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { withAssetVersion } from './shared/utils/asset-version';

@Injectable({ providedIn: 'root' })
export class TranslateService {

  data: any = {};

  constructor(private http: HttpClient) {}

  use(lang: string): Promise<{}> {
    return new Promise<{}>(resolve => {
      const langPath = `assets/i18n/${lang || 'en'}.json`;

      this.http.get(withAssetVersion(langPath)).subscribe(
        response => {
          this.data = {};
          if (response) this.data = response;
          resolve(this.data);
        },
        err => {
          this.data = {};
          resolve(this.data);
        }
      );
    });
  }

  istant(key: string): string{
    if (this.data[key])
      return this.data[key];
    else
      return key;
  }
}
